export const selectUsersLoading = (state) => state?.users?.isLoading;
export const selectUsers = (state) => state?.users?.data;

export const selectRecruitersIsLoading = (state) =>
  state?.users?.recruiters?.isLoading;
export const selectRecruiters = (state) => state?.users?.recruiters?.data;

export const selectOutreachusersIsLoading = (state) =>
  state?.users?.outreachUsers?.isLoading;
export const selectOutreachUsers = (state) => state?.users?.outreachUsers?.data;

export const selectExternalUsersIsLoading = (state) =>
  state?.users?.externalUsers?.isLoading;
export const selectExternalUsers = (state) => state?.users?.externalUsers?.data;
